const rootMargin = window.matchMedia('(max-width: 992px)').matches ? '-100px 0px' : '-200px 0px';
const sections = Array.from(document.querySelectorAll('.shopify-section'));

const revealSection = (section) => {
    section.classList.add('shopify-section--reveal');
};

const revealVisibleSections = () => {
    sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
            revealSection(section);
        }
    });
};

if (!('IntersectionObserver' in window)) {
    sections.forEach(revealSection);
} else {
    sections.forEach((section) => {
        const obs = new IntersectionObserver((entries, observer) => {
            if (entries[0] && entries[0].isIntersecting) {
                revealSection(section);
                observer.unobserve(section);
            }
        }, {
            rootMargin,
            root: null,
            threshold: 0
        });
        obs.observe(section);
    });

    revealVisibleSections();
    window.addEventListener('pageshow', revealVisibleSections);
    window.addEventListener('resize', revealVisibleSections);

    // Fallback: avoid permanently hidden sections if observer callbacks are delayed.
    window.setTimeout(() => {
        sections.forEach(revealSection);
    }, 1500);
}
